<template>
  <main class="flex h-screen min-h-screen w-screen items-center justify-center bg-gray-50">
    <div
      class="container mx-auto flex flex-col items-center justify-center p-5 text-gray-700 md:flex-row"
    >
      <div class="max-w-md text-center md:text-left">
        <div
          role="status"
          aria-live="polite"
        >
          <h1 class="text-lg font-bold md:text-4xl">Fragebogen abgeschlossen</h1>
          <p class="font-semi-bold mt-6 text-xl leading-normal md:text-3xl">
            Super, dieser Fragebogen ist bereits fertig ausgefüllt und abgeschickt.
          </p>
        </div>
        <p class="mb-8"></p>

        <div class="flex flex-col items-center space-y-4 md:items-start">
          <p class="text-gray-500">Benötigen Sie eine Kopie für Ihre Unterlagen?</p>

          <div class="flex space-x-4">
            <button
              v-if="!isExternalRoute"
              type="button"
              class="flex items-center rounded-lg border border-gray-200 border-transparent px-4 py-2 text-sm font-medium
                leading-5 text-gray-700 shadow transition-colors duration-150 focus:ring-2 focus:ring-offset-2
                md:text-base"
              :class="`hover:border-${themeColor}-600 hover:text-${themeColor}-600 focus:ring-${themeColor}-500`"
              @click="navigateToHome"
            >
              <svg
                class="mr-2 h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                />
              </svg>
              Zurück
            </button>

            <button
              type="button"
              class="rounded-lg border border-transparent px-4 py-2 text-sm font-medium leading-5 text-white shadow
                transition-colors duration-150 focus:ring-2 focus:ring-offset-2 md:text-base"
              :class="`bg-${themeColor}-600 active:bg-${themeColor}-600 hover:bg-${themeColor}-700
                focus:ring-${themeColor}-500`"
              aria-label="Fragebogen als PDF herunterladen"
              @click="handleDownloadClick"
            >
              PDF Download
            </button>
          </div>
        </div>
      </div>
      <div
        class="mt-10 max-w-lg md:mt-0"
        aria-hidden="true"
      >
        <ActionCompleted class="text-purple-600" />
      </div>
    </div>
  </main>
</template>

<script lang="ts">
  import { computed, defineComponent, PropType } from 'vue'
  import { basename, downloadBlob } from '@/lib/utils'
  import { useRouter, useRoute } from 'vue-router'
  import { useThemeColor } from '@/composables/useThemeColor'
  import ActionCompleted from '@/components/svg/Illustrations/ActionCompleted.vue'

  export default defineComponent({
    components: {
      ActionCompleted
    },
    props: {
      submissionUrl: {
        type: String as PropType<string>,
        required: true
      }
    },

    setup(props) {
      const router = useRouter()
      const route = useRoute()
      const themeColor = computed(() => useThemeColor().value)

      const isExternalRoute = computed(() => {
        return route.path.includes('/external/')
      })

      const handleDownloadClick = () => {
        downloadDocument(props.submissionUrl)
      }

      const navigateToHome = () => {
        router.push({
          path: `/client/portal`,
          query: { access_token: route.query.access_token?.toString() || '' }
        })
      }

      function downloadDocument(url: string, filename: string = basename(url)) {
        fetch(url)
          .then((response) => {
            return response.arrayBuffer()
          })
          .then((data) => {
            const blob = new Blob([data], { type: 'application/pdf' })
            downloadBlob(blob, filename)
          })
          .catch(console.error)
      }

      return {
        themeColor,
        handleDownloadClick,
        navigateToHome,
        isExternalRoute
      }
    }
  })
</script>
